import { TextField } from "@material-ui/core";
import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { CustomNumericFormat } from "../core/CustomNumericFormat";
import type { ListingType } from "../../../../../@types/listings/unions";

type ListingDialogInputApartmentNumberProps = {
  loading: boolean;
  listingType: ListingType;
  apartmentNumber: number | null;
  handleChange: ({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => void;
};

export function ListingDialogInputApartmentNumber({
  loading,
  listingType,
  apartmentNumber,
  handleChange
}: ListingDialogInputApartmentNumberProps): JSX.Element {
  const { t: translate } = useTranslation();

  return (
    <TextField
      fullWidth
      type="text"
      name="apartmentNumber"
      label={translate("listingsPage.tableColumns.apartmentNumber")}
      value={apartmentNumber}
      disabled={loading}
      onChange={handleChange}
      InputProps={{
        inputComponent: CustomNumericFormat as never
      }}
    />
  );
}

export function showApartmentNumberInput(type: ListingType): boolean {
  return listingTypeToShowApartment.includes(type);
}

const listingTypeToShowApartment: ListingType[] = [
  "duplex",
  "triplex",
  "pentHouse",
  "apartment",
  "gardenApartment"
];
